module.exports = __webpack_public_path__ + "static/media/vinyl-app.69e7e8b4.png";